import { InputForm, Error, SelectForm } from "components";
import {
  DcddUserInput,
  DcddUserInputError,
  GenericProps,
} from "../../../state/actionType";

interface Formprops {
  formData: DcddUserInput;
  error: DcddUserInputError;
  dzongkhagData: GenericProps[];
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
}

const HomeForm: React.FC<Formprops> = ({
  handleChange,
  formData,
  error,
  dzongkhagData,
}) => {
  return (
    <div className="grid grid-cols-2 gap-2">
      <div>
        <InputForm
          type="date"
          label="Data of Birth"
          id="dob"
          name="dob"
          value={formData.dob}
          onChange={handleChange}
        />
      </div>
      <div>
        <SelectForm
          type="text"
          styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
          label="Dzongkhag"
          id="dzongkhag_id"
          name="dzongkhag_id"
          value={formData.dzongkhag_id}
          option={dzongkhagData?.map((dzongkhag: GenericProps) => (
            <option
              key={dzongkhag.id.toString()}
              value={dzongkhag.id.toString()}
            >
              {dzongkhag.name}
            </option>
          ))}
          onChange={handleChange}
        />
        {error.dzongkhag_id && <Error>{error.dzongkhag_id}</Error>}
      </div>
      <div>
        <InputForm
          type="text"
          styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
          label="CID"
          id="cid"
          name="cid"
          value={formData.cid}
          onChange={handleChange}
        />
        {error.cid && <Error>{error.cid}</Error>}
      </div>
       <div>
        <InputForm
          type="text"
          label="Email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
        {error.email && <Error>{error.email}</Error>}
      </div>
      <div>
        <InputForm
          type="text"
          label="Mobile No."
          id="mobile_no"
          name="mobile_no"
          value={formData.mobile_no}
          onChange={handleChange}
        />
        {error.mobile_no && <Error>{error.mobile_no}</Error>}
      </div>
    </div>
  );
};

export default HomeForm;
